// extracted by mini-css-extract-plugin
export var table = "_v2-0";